import type { ComponentType } from "react";
import { EngageModule } from "./engage/components/EngageModule";
import { MyQueueModule } from "./myqueue/components/MyQueueModule";
import { TranscribeModule } from "./transcribe/components/TranscribeModule";
import { LogoCloudModule } from "./logocloud/components/LogoCloudModule";

export interface ConnectorPanelProps {
  readonly onBack?: () => void;
  readonly onOpenSettings?: () => void;
  readonly userEmail?: string;
}

/**
 * Maps a connector systemName to the React component that renders that
 * connector's panel. Used by ConnectorModuleShell to render one panel per
 * linked connection when a module has multiple connectors.
 */
export const CONNECTOR_PANELS: Partial<Record<string, ComponentType<ConnectorPanelProps>>> = {
  engage: EngageModule,
  "engage-workflow": EngageModule,
  myqueue: MyQueueModule,
  "myqueue-tasks": MyQueueModule,
  "engage-myqueue": MyQueueModule,
  // DocuParser is host-direct — no connector/credentials to resolve, so it's
  // not in this map — but it IS persona-gated (PERSONA_GATED_HOST_TILE_IDS in
  // TaskPane.tsx), same as Knowledge Base: connectorless modules are matched
  // by name, not by an entry here. See TaskPane.tsx's direct render.
  transcribe: TranscribeModule,
 "transcribe-qc": TranscribeModule,
  logocloud: LogoCloudModule,
};

// The Studio backend ships the OAuth helper as a paired `{name}-connection`
// systemName (e.g. `engage-workflow-connection`). Strip the suffix at lookup
// so the helper resolves to the same panel as its base connector — keeps
// CONNECTOR_PANELS focused on the canonical names.
export function normaliseSystemName(systemName: string): string {
  return systemName.toLowerCase().replace(/-connection$/, "");
}

export function getConnectorPanel(
  systemName: string,
): ComponentType<ConnectorPanelProps> | null {
  return CONNECTOR_PANELS[normaliseSystemName(systemName)] ?? null;
}
